var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('my_addresses.my_addresses')}},[_c('p',{staticClass:"user-help"},[_vm._v(_vm._s(_vm.$t('my_addresses.help')))]),_c('AddressList'),_c('VButtonGroup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }